"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const card_1 = require("./card");
const hand_1 = require("./hand");
const actionability_resolver_1 = require("./actionability-resolver");
const turn_1 = require("./turn");
class MaskedTurn extends turn_1.BaseTurn {
    constructor(state, players, gameParams) {
        super(state, players, gameParams);
        this.maskedPlayerViews = state.maskedPlayerViews.map(p => new hand_1.MaskedPlayerView(p));
        this.stockSize = state.stockSize;
        // refine
        const refined = this.maskedPlayerViews.map((_, idx) => turn_1.refineHand(this, idx));
        for (const [idx, mc] of refined.entries()) {
            if (this.maskedPlayerViews[idx].isMe) {
                this.maskedPlayerViews[idx].hand = mc;
            }
            else {
                this.maskedPlayerViews[idx].hand = actionability_resolver_1.resolveActionability(this.maskedPlayerViews[idx].hand.map(mc => new card_1.MaskedCard(mc)), this.table, this.discardPile);
                this.maskedPlayerViews[idx].extraMysticalHand = mc;
            }
        }
    }
    get inTurn() {
        return this.turnNumber % this._players.length;
    }
    getState() {
        const ret = JSON.parse(JSON.stringify(this)); // remove undefined values
        ret.inTurn = this.inTurn;
        ret.score = this.score;
        delete ret._players;
        delete ret._gameParams;
        return ret;
    }
    getExtraMysticalHandWithSpeculativeHint(toPlayerIdx, is) {
        const turnCopy = new MaskedTurn(this.getState(), this._players, this._gameParams);
        turnCopy.maskedPlayerViews[toPlayerIdx].hand = turnCopy.maskedPlayerViews[toPlayerIdx].hand.map(mc => {
            const c = new card_1.Card(mc); // not my own card, so it's always known
            c.addHint({ is, turnNumber: -1 });
            return new card_1.MaskedCard(c);
        });
        return turn_1.refineHand(turnCopy, toPlayerIdx);
    }
}
exports.MaskedTurn = MaskedTurn;
//# sourceMappingURL=masked-turn.js.map